import React, { useEffect, useContext, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import clsx from 'clsx';
import { isMobile } from 'react-device-detect';

//Material UI
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

//Contexts
import MainContext from 'store/MainContext';

//Utils
// import { getToken } from 'utils/firebase'; // FCM temporarily disabled

//APIs
import API from 'api/axios';

//Hooks
import useRules from 'hooks/useRules';

//Components
import AdminDrawer from 'components/Sidebar/AdminDrawer';
import AdminNavbar from 'components/Navbars/AdminNavbar';
import adminRoutes from './adminRoutes';
import Socket from 'components/Socket/AdminSocket';
import { useMainStore } from 'useStores/useMainStore';

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
  },
  content: {
    padding: isMobile ? theme.spacing(1) : theme.spacing(3),
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
}));

const NotificationAccessablity = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={() => {}} fullWidth>
      <DialogTitle>{'نوتیفیکیشن'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {'آیا میخواهید نوتیفیکیشن ها به شما نمایش داده شوند؟'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} variant="text" color="default">
          {'خیر'}
        </Button>
        <Button
          onClick={() => onClose(true)}
          variant={'contained'}
          color="secondary"
        >
          {'بله'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const Admin = () => {
  const { state, dispatch, showMessage, showError } = useContext(MainContext);
  const isMobile = useMediaQuery('(max-width:1350px)');
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [rules, hasRule, isAdmin] = useRules();
  // const [token, setToken] = useState(
  //   localStorage.getItem('@footab/admin/firebaseToken')
  // );
  // FCM temporarily disabled
  // const token = useMainStore((state) => state.firebaseToken);
  // const setToken = useMainStore((state) => state.setFirebaseToken);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  // FCM temporarily disabled
  // const sendFirebaseTokenToServer = async (firebaseToken) => {
  //   try {
  //     await API.put(`/api/v1/admin/user/firebaseToken`, {
  //       firebaseToken,
  //     });
  //   } catch (error) {}
  // };
  const localMessage = (color, position, title, content) => {
    showMessage(content, color, position);
  };

  // FCM temporarily disabled
  // async function getTokenFromFB() {
  //   try {
  //     setToken(true);
  //     const firebaseToken = await getToken();
  //     if (firebaseToken) {
  //       localStorage.setItem('@footab/admin/firebaseToken', firebaseToken);
  //       setToken(firebaseToken);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     showError(error);
  //   }
  // }

  const getRoutes = (routes) => {
    return routes.map((prop, key) => (
      <Route
        path={`/protected/admin${prop.path}`}
        render={() => (
          <prop.component config={prop} showMessage={localMessage} />
        )}
        key={key}
      />
    ));
  };

  // FCM temporarily disabled
  // function handleCloseNotificationDialog(ac) {
  //   if (ac === true) {
  //     getTokenFromFB();
  //   } else {
  //     localStorage.setItem('@footab/admin/firebaseToken', ac);
  //     setToken('false');
  //   }
  // }

  useEffect(() => {
    // FCM temporarily disabled
    // token?.length > 10 && sendFirebaseTokenToServer(token);
    localStorage.getItem('@footab/itemsCountPerPage') === null &&
      localStorage.setItem('@footab/itemsCountPerPage', 50);
  }, []);

  return (
    <React.Fragment>
      {/* FCM temporarily disabled
      <NotificationAccessablity
        open={token === null}
        onClose={handleCloseNotificationDialog}
      /> */}
      <Socket>
        <div className={classes.root}>
          <CssBaseline />
          <AdminNavbar open={open} openDrawer={handleDrawerOpen} />
          <AdminDrawer open={open} onClose={handleDrawerClose} />
          <main
            className={clsx(classes.content, {
              [classes.contentShift]: open,
            })}
          >
            <div className={classes.drawerHeader} />
            <Switch>
              {getRoutes(
                adminRoutes.filter(
                  (route) =>
                    hasRule(route.slug) || route.slug === 'sidemenu_password'
                )
              )}
              <Route
                exact
                path="/protected/admin"
                render={() => <Redirect to="/protected/admin/dashboard" />}
              />
              <Route path="*" render={() => <h3>این صفحه وجود ندارد</h3>} />
            </Switch>
          </main>
        </div>
      </Socket>
    </React.Fragment>
  );
};
export default Admin;
